import { Button, DialogActions, DialogTitle } from "@mui/material";
import { useDialog } from "../libs/dialog/DialogProvider";

export interface IConfirmProps {
    title:string;
    message:string;
    onYes:() => void
}
export default function Confirm(props:IConfirmProps){
    const {closeDialog} = useDialog()
    const yes=() => {
        closeDialog()
        props.onYes()
    }
    return <>
        <DialogTitle>{props.title}</DialogTitle>
        {props.message}
        <DialogActions>
            <Button onClick={yes}>Yes</Button>
        </DialogActions>
    </>
}